import React from "react";
import ImageCardWithDescription from "./ImageCardWithDescription";
import { navigationPropType } from "@template/state/modules/navigation";
import { createIdAriaDescribedBy } from "@template/helpers/navigationAccessibility";

import styles from "./index.css";

const ImageCardsWithDescription = ({ item }) => {
  const { label, items } = item;
  const headerId = createIdAriaDescribedBy(label);

  return (
    <ul className={styles.cardList} aria-labelledby={headerId}>
      {items.slice(0, 8).map(imageItem => (
        <ImageCardWithDescription item={imageItem} key={imageItem.id} />
      ))}
    </ul>
  );
};

ImageCardsWithDescription.propTypes = {
  item: navigationPropType.isRequired
};

export default ImageCardsWithDescription;
